import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHomeAttractionsData, getHeaderNotification, getFaqsData} from '../../utils/endpoints'
import InnerBanner from '../components/innerBanner';
import InnerContent from '../components/innerContent';
import { Container } from 'react-bootstrap';
import HeaderNotification from '../components/headerNotification';
import Header from '../components/header';
import Faqs from '../components/faq';
import Footer from '../components/footer';
import Loading from '../components/loading';
import GalleryCard from '../components/galleryCard';
import { Helmet } from 'react-helmet';

const AttractionDetails = (props) => {
    const [homeAttraction, setHomeAttraction] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const homeAttraction = await getHomeAttractionsData(id);
            const headerNotificationData = await getHeaderNotification();
            const faqs = await getFaqsData();
            setheaderNotificationData(headerNotificationData);
            setHomeAttraction(homeAttraction);
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
        return <div>Error: {error.message}</div>;
      }

  return (
    <div>
      <Helmet>
      <title>{homeAttraction[0]?.title?.rendered} || Statue of Belief || Worlds tallest shiva Statue</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <div className='mt-5 pt-5'>
      <Container>
        <h1 className="blog-heading" dangerouslySetInnerHTML={{ __html: homeAttraction[0]?.title?.rendered }}></h1>
        <InnerBanner compData={homeAttraction[0]?.acf} />
        <InnerContent compData={homeAttraction}/>
        <GalleryCard />
      </Container>
      </div>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default AttractionDetails;